export default __webpack_public_path__ + "static/media/Body_NFG.d33418d1.png";